export class Company {
  public uid: number;
  public name: string;
  public full_name: string;
  public address1: string;
  public address2: string;
  public address3: string;
  public city: string;
  public postalCode: string;
  public phone: string;
  public fax: string;
  public mail: string;
  public account_type: number;
  public mission_access: boolean;

  constructor(data: Partial<Company> = {}) {
    Object.assign(this, data);
  }
}
